import { CheckBoxWidget } from '@tableau/widgets';
import React from 'react';

import { IContentInfo } from '../../models/IContentInfo';
import { CardViewStyles } from './CardViewStyles';

export interface ContentCardSelectCheckboxProps {
  readonly content: IContentInfo;
  readonly selected?: boolean;
  readonly toggleSelection?: (content: IContentInfo) => void;
}

export const ContentCardSelectCheckbox = (props: ContentCardSelectCheckboxProps): JSX.Element => {
  return (
    <span className={CardViewStyles.SelectCheckbox}>
      {props.toggleSelection &&
      <CheckBoxWidget
        checked={props.selected}
        handleChange={() => props.toggleSelection(props.content)}
        testId="selection-checkbox"
      />
      }
    </span>
  );
};
